<template>
  <el-main class="materialwrap">
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>客户项目</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/project' }">项目列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{ pathtype }}项目</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form myform">
      <el-form ref="form" :model="form" :rules="rules" label-width="150px" label-position="left">
        <div class="formtitle">选择客户</div>
        <el-form-item label="选择客户：" prop="client_id">
          <el-col :span="12">
            <el-select v-model="form.client_id" placeholder="请选择" style="margin-right: 0; width: 100%;"
              @change="companyChange" filterable :disabled="form.status == '5'">
              <el-option :label="v.company" :value="v.id" v-for="(v, i) in clientList" :key="i"></el-option>
            </el-select>
          </el-col>
        </el-form-item>

        <el-form-item label="选择品牌：" prop="brand">
          <el-col :span="12">
            <el-select v-model="form.brand" placeholder="请选择" style="margin-right: 0; width: 100%;" @change="brandChange"
              clearable filterable :disabled="form.status == '5'">
              <el-option :label="item.brand" :value="item.brand" v-for="(item, index) in brandArr.brandList"
                :key="index"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <!-- 自动载入部分 -->
        <template v-if="form.brand">
          <el-form-item label="联系人姓名：" prop="name">
            <el-col :span="12">
              <el-input placeholder="请输入" maxlength="100" v-model="form.name" clearable :disabled="form.status == '5'" />
            </el-col>
          </el-form-item>
          <el-form-item label="联系人电话：" prop="phone">
            <el-col :span="12">
              <el-input placeholder="请输入" maxlength="100" v-model="form.phone" clearable :disabled="form.status == '5'" />
            </el-col>
          </el-form-item>
          <el-form-item label="联系人邮箱：" prop="email">
            <el-col :span="12">
              <el-input placeholder="请输入" maxlength="100" v-model="form.email" clearable :disabled="form.status == '5'" />
            </el-col>
          </el-form-item>
          <el-form-item label="付款账户：" prop="pay_company">
            <el-col :span="12">
              <el-input placeholder="请输入" maxlength="100" v-model="form.pay_company" clearable
                :disabled="form.status == '5'" />
            </el-col>
          </el-form-item>
          <el-form-item label="银行名称：" prop="pay_bank">
            <el-col :span="12">
              <el-input placeholder="请输入" maxlength="100" v-model="form.pay_bank" clearable
                :disabled="form.status == '5'" />
            </el-col>
          </el-form-item>
          <el-form-item label="银行账号：" prop="pay_bank_account">
            <el-col :span="12">
              <el-input placeholder="请输入" maxlength="100" v-model="form.pay_bank_account" clearable
                :disabled="form.status == '5'" />
            </el-col>
          </el-form-item>
          <el-form-item label="统一社会信用代码：" prop="company_id_card">
            <el-col :span="12">
              <el-input placeholder="请输入" maxlength="100" v-model="form.company_id_card" clearable
                :disabled="form.status == '5'" />
            </el-col>
          </el-form-item>
          <el-form-item label="公司注册地址：" prop="reg_address">
            <el-col :span="12">
              <el-input placeholder="请输入" maxlength="100" v-model="form.reg_address" clearable
                :disabled="form.status == '5'" />
            </el-col>
          </el-form-item>
          <el-form-item label="公司电话：" prop="company_phone">
            <el-col :span="12">
              <el-input placeholder="请输入" maxlength="100" v-model="form.company_phone" clearable
                :disabled="form.status == '5'" />
            </el-col>
          </el-form-item>
        </template>

        <div class="formtitle">项目信息</div>
        <el-form-item label="项目名称：" prop="contract_name">
          <el-col :span="12">
            <el-input placeholder="请输入" maxlength="100" v-model="form.contract_name" clearable
              :disabled="form.status == '5'" />
          </el-col>
        </el-form-item>

        <el-form-item label="项目时间：" prop="project_time">
          <el-col :span="12">
            <el-date-picker v-model="form.project_time" type="datetimerange" range-separator="--"
              value-format="yyyy-MM-dd" start-placeholder="项目开始时间" end-placeholder="项目结束时间" style="width:100%;"
              @change="contractTime" :disabled="form.status == '5'">
            </el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item label="选择项目负责人：" prop="manager_id">
          <el-col :span="12">
            <el-select v-model="form.manager_id" placeholder="请选择" style="margin-right: 0; width: 100%;"
              @change="managerChange" :disabled="form.status == '5'">
              <el-option :label="`${v.realname} ${v.en_name}`" :value="v.id" v-for="(v, i) in userList" :key="i"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="项目状态：" prop="status">
          <el-col>
            <el-radio-group v-model="form.status">
              <el-radio label="1">未开始</el-radio>
              <el-radio label="2">进行中</el-radio>
              <el-radio label="3">项目终止</el-radio>
              <el-radio label="4">已完成</el-radio>
              <el-radio label="5">已归档</el-radio>
            </el-radio-group>
          </el-col>
        </el-form-item>
        <el-form-item label="项目完成时间：" prop="finish_time">
          <el-col :span="5">
            <el-date-picker v-model="form.finish_time" type="datetime" value-format="yyyy-MM-dd" placeholder="项目完成时间"
              style="width: 100%;" :disabled="form.status == '5'">
            </el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item label="">
          <el-col :span="10">
            <el-button @click="resetForm('form')">取消</el-button>
            <el-button type="primary" @click="submitForm('form')">保存</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </div>
  </el-main>
</template>

<script>
import * as api from '@/api'
import { timeFormat } from '@/utils/index.js'
export default {
  name: 'prodetail',
  data() {
    return {
      nodeLimtList: [],
      conShow: false,
      clientList: [],
      userList: [],
      projectList: [],
      brandArr: {
        brandList: []
      },
      form: {
        //客户信息
        project_id: '',
        client_id: '',
        client_company: '',
        brand: '',
        name: '',
        phone: '',
        email: '',
        pay_company: '',
        pay_bank: '',
        pay_bank_account: '',
        company_id_card: '',
        reg_address: '',
        company_phone: '',
        //项目信息
        contract_name: '',
        project_time: ['', ''],
        manager_id: '',
        manager_name: '',
        status: '1',
        finish_time: '',
      },
      p: 1,
      type: 0,
      rules: {
        client_company: [
          {
            required: true,
            message: '请输入客户公司名称',
            trigger: 'change',
          },
        ],
        brand: [
          {
            required: true,
            message: '请输入品牌',
            trigger: 'change',
          },
        ],
        name: [
          {
            required: true,
            message: '请输入联系人姓名',
            trigger: 'change',
          },
        ],
        phone: [
          {
            required: true,
            message: '请输入联系人电话',
            trigger: 'change',
          },
        ],
        pay_company: [
          {
            required: true,
            message: '请输入付款账户',
            trigger: 'change',
          },
        ],
        pay_bank: [
          {
            required: true,
            message: '请输入银行名称',
            trigger: 'change',
          },
        ],
        pay_bank_account: [
          {
            required: true,
            message: '请输入银行账号',
            trigger: 'change',
          },
        ],
        company_id_card: [
          {
            required: true,
            message: '请输入统一社会信用代码',
            trigger: 'change',
          },
        ],
      },
    }
  },
  created() {
    this.query = this.$route.query
    this.query.id && this.getDetail(this.query.id)
    !this.query.id && this.checkUrlFn()
  },
  mounted() {
    this.getClientList()
    this.getUserList()
  },
  watch: {
    ['form.pay_bank_account'](val) {
      if (val != undefined) {
        this.$nextTick(() => {
          this.form.pay_bank_account = val.replace(/\D/g, '').replace(/....(?!$)/g, '$& ');
        });
      }
    },
    ['form.phone'](val) {
      if (val != undefined) {
        this.$nextTick(() => {
          this.form.phone = val.replace(/\D/g, '');
        });
      }
    },
    ['form.company_phone'](val) {
      if (val != undefined) {
        this.$nextTick(() => {
          this.form.company_phone = val.replace(/\D/g, '');
        });
      }
    },
  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;  
      // 移除'#'字符  
      const url = hash.substring(1); 
      
      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },
    async getClientList() {
      this.$fly.post('apiSale_getClientList.html', {
        per_page: 5000,
      })
        .then((res) => {
          this.clientList = res.itemList
        })
    },
    async getUserList() {
      this.$fly
        .post('apiAccount_getUserList.html', {
          per_page: 5000,
        })
        .then((res) => {
          this.userList = res.itemList.filter((item) => item.status == '1')
        })
    },
    companyChange(v) {//公司变化，清空品牌
      return new Promise((resolve, reject) => {
        this.$fly
          .post('apiSale_getClientDetail.html', { client_id: v })
          .then((res) => {
            if (res) {
              this.brandArr = res.itemArr
              this.form = {
                ...this.form,
                client_company: this.brandArr.company,
                brand: '',
                name: '',
                phone: '',
                email: '',
                pay_company: '',
                pay_bank: '',
                pay_bank_account: '',
                company_id_card: '',
                reg_address: '',
                company_phone: '',
              }     
              resolve(res)                   
            } else {
              reject('error')
            }
          })
      })
    },
    brandChange(v) {//品牌变化，重新填写内容
      // console.log('品牌：', v);
      const {
        pay_company,
        pay_bank,
        pay_bank_account,
        company_id_card,
        reg_address,
        company_phone,
      } = this.brandArr
      this.form = {
        ...this.form,
        pay_company,
        pay_bank,
        pay_bank_account,
        company_id_card,
        reg_address,
        company_phone,
      }
      this.brandArr.brandList.forEach(item => {
        if (item.brand == v) {
          // console.log('品牌：', v);
          const {
            brand,
            name,
            phone,
            email
          } = item
          this.form = {
            ...this.form,
            brand,
            name,
            phone,
            email
          }
        }
      })
    },
    managerChange(v) {
      let manager_name = ''
      this.userList.forEach(item => {
        if (item.id == v) {
          manager_name = item.realname
        }
      })
      this.form.manager_name = manager_name
    },
    //项目时间调整
    contractTime() {
      const time = this.form.project_time || ['', '']
      this.form.project_start_time = this.fdate(time[0])
      this.form.project_end_time = this.fdate(time[1])
    },
    async getDetail(id) {
      this.checkUrlFn()
      this.$fly
        .post('apiProject_getDetail.html', {
          project_id: id,
        })
        .then((res) => {
          let form = res.itemArr
          delete form.is_apply
          //修改0000-00-00错误显示1899年情况
          form.project_start_time = timeFormat(form.project_start_time)
          form.project_end_time = timeFormat(form.project_end_time)
          form.finish_time = timeFormat(form.finish_time)
          //初始project_time
          form.project_time = ['', '']
          form.project_time[0] = form.project_start_time
          form.project_time[1] = form.project_end_time         
          this.form = form
          // this.companyChange(form.client_id).then(() => {
          //   this.brandChange(form.brand)
          // })           
        }) 
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addUpdateProject()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    addUpdateProject() {
      this.form.project_id = this.query.id || ''
      this.form.option = this.form.id ? '2' : '1'
      const tempForm = JSON.parse(JSON.stringify(this.form))
      delete tempForm.fileList
      delete tempForm.contract_start_time
      delete tempForm.contract_end_time
      this.$fly
        .post('apiProject_addUpdate.html', {
          ...tempForm,
          finish_time: tempForm.finish_time == '' ? '0000-00-00' : tempForm.finish_time
        })
        .then((res) => {
          if (res.status === 200) {
            this.$message.success(res.message)
          }
          this.$router.go(-1)
        })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.$router.go(-1)
    },
  },
}
</script>

<style lang="scss" scoped>
.materialwrap {
  .form.myform {
    padding-left: 100px;
  }

  .form {
    @extend %box;
    padding: 30px;
    margin-bottom: 20px;
    .anlist {
      padding: 0;
      flex-flow: column nowrap;

      li {
        position: relative;
        padding: 0;

        .abtn {
          position: absolute;
          top: 0;
          left: 65%;
        }

        .bbtn {
          position: absolute;
          top: 0;
          left: 60%;
        }
      }
    }
  }

  .formtitle {
    position: relative;
    left: -50px;
    margin-bottom: 30px;
    font-size: 28px;
    line-height: 48px;
    font-weight: 600;
  }
}
</style>
